import {
  observer,
} from 'mobx-react';
import React, {
  Component,
} from 'react';
import {
  stores,
} from 'mobx-store';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';

interface IProps {
  history: any;
}

interface TableData {
  title: string;
  edit: string;
}

@observer
class CustomScreens extends Component<IProps> {
  customScreensStore = stores.customScreenStore.Stores.customScreens;

  tableHeader: any = [];

  tableData: TableData[] = [];

  tableCellTypes: TableCellTypes[] = [];

  title = 'Custom Screens Management';

  addButton: any;

  handleTableButtonCellClicked = (index: number, key: string) => {
    this.customScreensStore.getWidgets(stores.countryStore.managedCountries);
    this.props.history.push(`/custom-screens/${this.customScreensStore.customScreens[index].customScreenKey}/edit`);
  };

  handelAdd = (): void => {
    this.customScreensStore.getWidgets(stores.countryStore.managedCountries);
    this.props.history.push('/custom-screens/new');
  };

  getAddButton = () => ({
    title: 'Add',
    onAdd: this.handelAdd,
  });

  getTableHeader = () => [
    {
      title: 'Screen',
    },
    {
      title: 'Edit',
    },
  ];

  getTableData = () => this.customScreensStore.customScreens
    .map((customScreen) => {
      const customScreenData = {
        title: customScreen.name,
        edit: 'Edit',
      };
      return customScreenData;
    });

  getTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'title',
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: this.handleTableButtonCellClicked,
    },
  ];

  render() {
    this.addButton = this.getAddButton();
    this.tableHeader = this.getTableHeader();
    this.tableData = this.getTableData();
    this.tableCellTypes = this.getTableCellTypes();
    return (
      <div>
        <GeneralTableComponent
          emptyMessage="There are no custom Screens yet. Please add one now"
          title={this.title}
          tableHeader={this.tableHeader}
          tableData={this.tableData}
          tableCellTypes={this.tableCellTypes}
          loadingStatus={[
            this.customScreensStore.requestStatus,
          ]}
        />
      </div>
    );
  }

  async componentDidMount() {
    await stores.countryStore.getUserManagedCountries();
    await this.customScreensStore.getCustomScreens(stores.countryStore.managedCountries);
  }
}

export default CustomScreens;
